import axios from '../../axios';
import * as TYPES from '../types';

const state = {
  taxFilings: [],
  taxFilingDetail: null,
};
const getters = {
  taxFilings: state => state.taxFilings,
  taxFilingDetail: state => state.taxFilingDetail,
};
const mutations = {
  [TYPES.SET_TAX_FILINGS](state, payload) {
    state.taxFilings = payload;
  },
  [TYPES.SET_TAX_FILING_DETAIL](state, payload) {
    state.taxFilingDetail = payload;
  },
};
const actions = {
  /**
   * 获取报税记录
   * @param commit
   * @param ts
   * @param params
   */
  getTaxFilings: ({commit}, {ts, params}) => {
    commit(TYPES.SET_LOADING, true);
    axios
      .get("/tax-filings" + ts, {params: {...params,sort:'createDate,desc'}})
      .then(response => {
        commit(TYPES.SET_TAX_FILINGS, response.data.data);
        commit(TYPES.SET_LOADING, false);
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.message);
        commit(TYPES.SET_LOADING, false);
      });
  },

  /**
   * 获取报税详情
   * @param commit
   * @param taxFilingId
   */
  getTaxFilingDetail:({commit}, taxFilingId)=>{
    commit(TYPES.SET_TAX_FILING_DETAIL, null);
    commit(TYPES.SET_LOADING, true);
    axios
      .get("/tax-filings/" + taxFilingId)
      .then(response => {
        commit(TYPES.SET_TAX_FILING_DETAIL, response.data);
        commit(TYPES.SET_LOADING, false);
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.message);
        commit(TYPES.SET_LOADING, false);
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
}